export default __webpack_public_path__ + "static/media/cross_icon.527f257e.svg";